// eslint-disable-next-line no-unused-vars
const StatCard = ({ icon: Icon, value, label, color = 'text-white', className = "" }) => {
  return (
    <div className={`bg-card/80 backdrop-blur shadow-soft border-0 hover:shadow-strong transition-smooth rounded-lg p-6 text-center ${className}`}>
      <div className="w-12 h-12 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-4 shadow-soft">
        <Icon className={`w-6 h-6 ${color}`} />
      </div>
      <div className="text-2xl font-bold mb-1 text-primary">
        {value}
      </div>
      <div className="text-sm text-muted-foreground">{label}</div>
    </div>
  )
}

export default StatCard